import axios from "axios";

// Function to get the idToken from localStorage or wherever you store it
const getIdToken = () => {
  return localStorage.getItem("idToken"); // Or wherever you're storing the token
};

const AxiosClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 10000,
});

// Add an interceptor to the instance to include the idToken in every request
AxiosClient.interceptors.request.use(
  (config) => {
    const idToken = getIdToken(); // Retrieve the idToken

    if (idToken) {
      // Add Authorization header with the Bearer token if it exists
      config.headers["Authorization"] = `Bearer ${idToken}`;
      config.headers["user_email"] = localStorage.getItem("userId");
      config.headers["user_name"] = localStorage.getItem("userName");
    }

    return config; // Continue the request with updated headers
  },
  (error) => {
    return Promise.reject(new Error(error)); // If there's an error, reject the promise
  }
);

export default AxiosClient;
